import { CalendarDays } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

/**
 * Benamingen (akkoord eigenaar, 6/10/2026): module = Planning; tabs Agenda · Lijst · Routes · Bezetting,
 * onder "Meer ▾": Cijfers · Seizoenen · Conflicten · Agenda-koppeling.
 * De URL's blijven ongewijzigd (/planning/agenda = Lijst, /planning/capaciteit = Bezetting, …);
 * de nieuwe namen bestaan enkel als redirect-alias (zie index.tsx).
 */
const planningManifest: ModuleDefinition = {
  id: 'planning',
  name: 'Planning',
  icon: <CalendarDays size={20} />,
  color: 'var(--brand-primary)',
  basePath: '/planning',
  status: 'active',
  navItems: [
    { label: 'Agenda', labelKey: 'planning.nav.agenda', path: '/planning', icon: '' },
    { label: 'Lijst', labelKey: 'planning.nav.lijst', path: '/planning/agenda', icon: '' },
    { label: 'Routes', labelKey: 'planning.nav.routes', path: '/planning/routes', icon: '' },
    { label: 'Bezetting', labelKey: 'planning.nav.bezetting', path: '/planning/capaciteit', icon: '' },
    { label: 'Beschikbaarheid', labelKey: 'planning.nav.beschikbaarheid', path: '/planning/beschikbaarheid', icon: '' },
    { label: 'Cijfers', labelKey: 'planning.nav.cijfers', path: '/planning/analytics', icon: '', menu: 'meer' },
    { label: 'Seizoenen', labelKey: 'planning.nav.seizoenen', path: '/planning/seizoenen', icon: '', menu: 'meer' },
    { label: 'Conflicten', labelKey: 'planning.nav.conflicten', path: '/planning/conflicten', icon: '', menu: 'meer' },
    { label: 'Agenda-koppeling', labelKey: 'planning.nav.agendaKoppeling', path: '/planning/export', icon: '', menu: 'meer' },
  ],
  component: () => import('./index.js'),
};

export default planningManifest;
